import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

// Global Types
import { AppState } from 'services/types';

// Global Actions
import {
    requestLoadSprayEvents,
    canceledLoadSprayEvents
} from 'services/sprayEvents/actions';

// Global Selectors
import { selectLoadSprayEventsParams } from 'services/sprayEvents/params';

interface ConnectedProps {
    params?: Record<string, any>;
}

interface DispatchProps {
    requestLoadSprayEvents: Function;
    canceledLoadSprayEvents: Function;
}

type Props = ConnectedProps & DispatchProps;

export class SprayEventsRequest extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { props } = this;
        props.requestLoadSprayEvents();
    }

    componentDidUpdate(prevProps: Props): void {
        const { props } = this;
        if (!isEqual(prevProps.params, props.params)) {
            props.requestLoadSprayEvents();
        }
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.canceledLoadSprayEvents();
    }

    render(): null {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    params: selectLoadSprayEventsParams
});

export default connect(
    mapStateToProps,
    {
        requestLoadSprayEvents,
        canceledLoadSprayEvents
    }
)(SprayEventsRequest);
